import { mixed, number, object } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const getValidationSchema = () => object({
  startDate: mixed().when('periodType', {
    is: (type) => type === 'fixed',
    then: mixed().required(I18n.t('errors.messages.blank'))
  }),
  maxBookingTime: mixed().when('periodType', {
    is: (type) => type === 'rollingDays',
    then: number()
      .typeError(I18n.t('errors.messages.not_a_number'))
      .required(I18n.t('errors.messages.blank'))
      .positive(I18n.t('errors.messages.greater_than', { count: 0 }))
      .max((2 ** 31) / 24 / 60, I18n.t('errors.event_types.max_booking_time.too_large'))
  }),
})
